<template>
	<div class="section">
		<div class="container is-small">
			<div class="section-body">
				<div class="section-img">
					<img src="@/assets/check-circle.svg">
				</div>
				<h2 class="section-subtitle is-black">
					Request was successful!
				</h2>
				<h3 class="section-subtitle is-small-thin">
					After we have checked your request, we will send you a login link by e-mail. This process can take up to 24 hours.
					<br><br>
					Keep an eye on this!
				</h3>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MailRequest',
};
</script>

<style lang="scss" scoped>
.section {
	position: relative;
	background-color: $color-accent-100;
	height: 100vh;
	width: 100vw;

	.section-header {
		position: relative;
		z-index: 5000;
	}

	.section-body {
		padding: $gap-5 0;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.section-subtitle {
			padding-bottom: $gap-4;
		}

	}

	.section-img {
		width: 130px;
		margin-bottom: $gap-2;

		img {
			width: 100%;
		}
	}

	.section-footer {
		position: absolute;
		width: 100%;
		bottom: 0;
	}
}
</style>
